import React, { useEffect, useState } from "react";
import { isErrorDispaly } from "../../shared/validationsAndExceptions/apiExceptions";
import { connect } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment/moment";
import Loader from "../../shared/loader";
import { Empty, Tooltip, Input, Form, Select, DatePicker,Typography, Menu, Checkbox, Dropdown } from "antd";
import { utils, writeFile } from 'xlsx';
import Breadcrumb from "../../layout/componentsBreadcrumb";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import AppRow from "../../shared/appRow";
import AppAlert from "../../shared/appAlert";
import AppCol from "../../shared/appCol";
import { debouncedGrid, getTypes } from "./service";
import Moment from "react-moment";
import { convertUTCToLocalTime } from "../../utils/service";
import CopyToClipboard from "react-copy-to-clipboard";
import AppText from "../../shared/appText";
import NumberFormat from "react-number-format";
import { getRecentPayments } from "./api";
import FormItem from "antd/lib/form/FormItem";
import { EmailShareButton, WhatsappShareButton } from "react-share";
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Title} = Typography;
const ViewPaymentLinksComponent = (props) => {
  const [form] = Form.useForm();
  const [searchGridDataFilter, setSearchGridDataFilter] = useState([]);
  const [loader, setLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [searchQuery, setSearchQuery] = useState(null);
  const [transactionLu, setTransactionLu] = useState([]);
  const [transactionType, setTransactionType] = useState('All');
  const [selectedDates, setSelectedDates] = useState([]);
  const [selection, setSelection] = useState([]);
  const history = useHistory()
  const [pageNo, setPageNo] = useState(1);
  let pageSize = 20
  const { Search } = Input;
  const breadCrumbList = [
    { id: "1", bname: "Payment Artha",url : '/dashboard' },
    { id: "2", bname: "Payment Links", }
  ];
  const [totalGridDataCount, setTotalGridDataCount] = useState(50)
  useEffect(() => {
    form.setFieldsValue('transactionType', "All");
    getTransactipnTypeLu();
    getTransactionGrid(0, props?.userConfig?.id, null, pageNo, transactionType, selectedDates)
  }, []);
  const getTransactipnTypeLu = async () => {
    try {
      let response = await getTypes('Merchant/typeslookup');
      setTransactionLu(response);
    }
    catch (error) {
      setErrorMessage(error);
    }
  }
  const fetchMoreData = () => {
    if (searchGridDataFilter.length < totalGridDataCount) {
      getTransactionGrid(0, props.userConfig.id, searchQuery || null, pageNo, transactionType, selectedDates);
    }
  };
  const gridCallback = (data, error) => {
    if (data.data?.length) {
      setPageNo(prevPageNo => prevPageNo + 0)
      setSearchGridDataFilter(prevData => [...prevData, ...data.data]);
      setLoader(false)
      setTotalGridDataCount(data.total)
      setErrorMessage(null);
      return
    }
    setErrorMessage(error)
    setLoader(false)
  }
  const getTransactionGrid = async (timeout, id, search, pageNumber, selectedTransactionType, setSelectedDatesData) => {
    setLoader(true);
    debouncedGrid(timeout, id, search, gridCallback, pageNumber, pageSize, selectedTransactionType, setSelectedDatesData)
  };
  const handleSearchGrid = (e) => {
    const searchList = e.target.value?.replace(/^\s+/, '');
    setSearchQuery(searchList);
    if (searchList.length > 2) {
      setSearchGridDataFilter([])
      setPageNo(1)
      setLoader(true)
      setTotalGridDataCount(50)
      getTransactionGrid(1000, props?.userConfig?.id, searchList, 1, transactionType, selectedDates)
    }
    if (searchList === "") {
      setSearchGridDataFilter([]);
      getTransactionGrid(1000, props?.userConfig?.id, null, 1, transactionType, selectedDates)
    }
  };
  const handleExportToExcel = async () => {
    let _fromDate = selectedDates?.length >0 ? selectedDates[0] : '';
    let _toDate = selectedDates?.length > 0 ?  selectedDates[1] : '';
    const response = await getRecentPayments(props?.userConfig?.id, searchQuery || null, null,null, transactionType,_fromDate,_toDate );
    if (response.ok) {
      const dataToExport = response.data.data;
      const excelData = dataToExport.map((item) => {
        return {
          "Date": moment.utc(item.date).local().format("DD/MM/YYYY hh:mm:ss A") || "-",
          "Merchant Account":item.merchantName || "-",
          "Wallet Address": item.walletAddress || "-",
          "Value": item.amount || "-",
          "Coin": item.currency || "-",
          "Network": item.network || "-",
          "Payment Type" : item.type || "-",
          "Status": item?.state
        };
      });
      const worksheet = utils.json_to_sheet(excelData);
      const workbook = utils.book_new();
      utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
      const columnWidths = [{ wch: 22 }, { wch: 22 }, { wch: 22 }, { wch: 22 }, { wch: 15 }, { wch: 15 }, { wch: 25 }];
      worksheet['!cols'] = columnWidths;
      writeFile(workbook, 'Payment Links.xlsx');
      setErrorMessage(null);
    } else {
      setErrorMessage(isErrorDispaly(response));
    }
  };
  const handleOpen = (item) => {
    history.push(`/paymentLinkView/${item?.id}/${item?.merchantName}`)
  }
  const handleDates = (dates, dateStrings) => {
    setSearchGridDataFilter([])
    setSelectedDates(dateStrings);
    getTransactionGrid(1000, props?.userConfig?.id, null, pageNo, transactionType, dateStrings)
  };
  const handleTransactions = (e) => {
    setSearchGridDataFilter([])
    setTransactionType(e)
    getTransactionGrid(1000, props?.userConfig?.id, null, pageNo, e, selectedDates)
  }
  const handleSelection = (dataItem) => {
    let _selection = [...selection];
    const idx = _selection.indexOf(dataItem);
    if (idx > -1) {
        _selection.splice(idx, 1);
    } else {
        _selection[0] = dataItem
        setErrorMessage(null);
    }
    setErrorMessage(null);
    setSelection(_selection);
}
const addPaymentLink = () =>{
  history.push(`/createpaymentlink/create`)
}
const share = () =>{
  if(selection.length === 0 ){
    setErrorMessage('Plese select one record.')
    return Promise.reject();
  }
  else if(selection[0].state.toLowerCase()== "paid"){
    setErrorMessage('This record has already been paid.')
    return Promise.reject();
  }
  else{
    return Promise.resolve()
  }
}
const editPaymentLink = ()=>{
  if(selection.length === 0 ){
    setErrorMessage('Plese select one record.')
    console.log('pls select check box');
  }else if(selection[0].state.toLowerCase()== "paid" || selection[0].state.toLowerCase()== "partially paid"){
    setErrorMessage('This record has already been paid.')
  }else{
      history.push(`/createpaymentlink/${selection[0].id}/${selection[0].merchantName}?`)
  }
}
const menu = (
  <Menu className="share-payment-link">
      <ul className="dropdown-list">
      <FormItem>
        <div className="d-flex share-icons">
          <Menu className="share-adrs text-center">
            <Menu.Item >
              <WhatsappShareButton beforeOnClick={share} url={`${selection[0]?.paymentLink} \nThank you.`}
                title={`Hello, I would like to share my ` + `${selection[0]?.currency} ` + `(${selection[0]?.network}) ` + ` address for receiving: ` + `\n${selection[0]?.walletAddress}` + `\nPlease make sure you are using the correct protocol otherwise you are risking losing the funds.\nI am using Payment Gateway:`} >
             <span className='icon lg whatsapp'></span> </WhatsappShareButton>
            </Menu.Item>
            <Menu.Item>
                  <EmailShareButton beforeOnClick={share} url={`${selection[0]?.paymentLink}\nThank you.`} subject={"Wallet Address"} body={`Hello, I would like to share my ` + `${selection[0]?.currency} ` + `(${selection[0]?.network}) ` + ` address for receiving: ` + `\n${selection[0]?.walletAddress}` + `\nPlease make sure you are using the correct protocol otherwise you are risking losing the funds.\nI am using Payment Gateway:\n`}> <span className='icon lg mail'></span></EmailShareButton>
                </Menu.Item>
              </Menu>
            </div>
        </FormItem>
      </ul>
  </Menu>
);
  return (
    <>
    <Breadcrumb breadCrumbList={breadCrumbList} />
      <div className='d-lg-flex align-start transactions-header'>
        <Form
        form={form}
        initialValues={{}}
        className="d-flex payment-filters gap-16"
      >
        <Form.Item
          name="transactionType"
          className="mb-0 payee-field "
          colon={false}
        >
          <Select
            onChange={(e) => handleTransactions(e)}
            placeholder="Payment Type"
            className="payee-input input-bordered"
            maxLength={30}
            defaultValue={'All'}
          >
            {transactionLu.map((item, index) => (
              <Option key={index} value={item.name}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="dates"
          className="mb-0 payee-field "
          colon={false}
        >
          <RangePicker className="payee-input input-bordered text-white" onChange={handleDates} />
        </Form.Item>
      </Form>
      <div className="d-flex align-center transactions-search sm-mt-16">
          <div className="coin-search mb-0">
            <Search value={searchQuery} placeholder='Search Payment Link' suffix={<span className="icon md search c-pointer" />}
              onChange={handleSearchGrid} size="middle" bordered={false} className="coin-search-input " />
          </div>
          <div className="d-flex xs-flex-end">
          <div className="text-right export-pdf secureDropdown">
            <Tooltip placement="top" title={"Export Excel"}>
              <button className="c-pointer btn-style"
                onClick={() => {
                  handleExportToExcel()
                }}
              >
                <span className="icon excel"></span>
                <span
                  className="icon xl mr-0 excelexport"
                ></span></button>
            </Tooltip>
          </div>
              <Dropdown placement="topRight" overlay={menu} className="" trigger={['click']}
                overlayClassName="paylinks-dropdown" >
                            <a className="d-flex align-items-center">
                            <div className="text-right export-pdf secureDropdown">
                  <button className="c-pointer btn-style"
                  >
                    <span className="icon share-icon"></span>
                  </button>
              </div>
                            </a>
                        </Dropdown>
              <div className="text-right export-pdf secureDropdown">
                <Tooltip placement="top" title={"Create Payment Link"}>
                  <button className="c-pointer btn-style" onClick={addPaymentLink} >
                    <span className="icon add-links"></span>
                  </button>
                </Tooltip>
              </div>
              <div className="text-right export-pdf secureDropdown">
                <Tooltip placement="top" title={"Edit Payment Link"}>
                  <button className="c-pointer btn-style" onClick={editPaymentLink} >
                    <span className="icon Edit-links"></span>
                  </button>
                </Tooltip>
              </div>
          </div>
        </div>
      </div>
      <AppRow>
        {errorMessage !== undefined && errorMessage !== null && errorMessage !== "" && (
          <div className="alert-flex" style={{ width: "100%" }}>
            <AppAlert
              className="w-100 "
              type="warning"
              description={errorMessage}
              showIcon
            />
            <button className="icon sm alert-close" onClick={() => setErrorMessage(null)}></button>
          </div>
        )}
        <AppCol xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
          <div className="layout-bg left-panel pannel-bg mt-14 sm-m-0 transactions-scroll">
            <InfiniteScroll
              className="table-scroll"
              dataLength={searchGridDataFilter?.length}
              next={fetchMoreData}
              hasMore={searchGridDataFilter?.length < totalGridDataCount}
              endMessage={searchGridDataFilter?.length > 0 &&
                <div className="text-center">
                  {searchGridDataFilter?.length !== 0 && <span className="text-white">Yay! You have seen it all </span>}
                </div>}
            >
              <table style={{width:"100%",minWidth:1250}} className="alltransactions-table">
                {searchGridDataFilter && <>
                  {searchGridDataFilter?.map((item,index) =>
                    <tr key={index} className="custom-table card">
                     <td className="" width={50}>
                      <div className="paymentlinks-checkbox">
                      <Form.Item  className={`policy-content`} >
                        <Checkbox onChange={() => { handleSelection(item) }} checked={selection.indexOf(item) > -1} className="mr-6"></Checkbox>
                      </Form.Item>
                      </div>
                      </td>
                    <td className="" width={230}>
                      <label className="table-label">Date</label>
                      <Title level={4} className="table-text text-link c-pointer">
                      <Moment format="DD/MM/YYYY hh:mm:ss A" onClick={()=>handleOpen(item)}>
                  {item?.date && convertUTCToLocalTime(item?.date)}
                </Moment>
                      </Title>
                    </td>
                    <td className="" width={220}>
                      <label className="table-label">Merchant Account</label>
                      <Title level={4} className="table-text">{item?.merchantName}</Title>
                    </td>
                    <td className="" width={160}>
                      <div className="">
                        <label className="table-label">Wallet Address</label>
                        <Title level={4} className="table-text text-white"> {item?.walletAddress && <CopyToClipboard text={item?.walletAddress} options={{ format: 'text/plain' }}><AppText copyable={{ tooltips: ['Copy', 'Copied'] }} className="summary-text m-0">{item?.walletAddress.substring(0, 4)}...{item?.walletAddress.substring(item?.walletAddress.length - 4)}</AppText></CopyToClipboard>}</Title>
                      </div>
                    </td>
                    <td className="">
                      <label className="table-label">Value</label>
                      <Title level={4} className="table-text">  <NumberFormat value={item?.amount} displayType="text" thousandSeparator={true} /></Title>
                    </td>
                    <td className="">
                      <label className="table-label">Coin</label>
                      <Title level={4} className="table-text">
                      <span className={`crypto coin sm ${item?.currency?.toLowerCase()}`}></span> {item?.currency}
                      </Title>
                    </td>
                    <td className="">
                      <label className="table-label">Network</label>
                      <Title level={4} className="table-text">
                     {item.network}
                      </Title>
                    </td>
                    <td className="">
                      <label className="table-label">Payment Type</label>
                      <Title level={4} className="table-text">{item?.type}</Title>
                    </td>
                    <td className="">
                      <label className="table-label">Status</label>
                      <Title level={4} className={`table-text text-green ${item?.state == 'NotPaid' ? 'text-blue' : ''} ${item?.state == 'Not Paid' ? 'text-blue' : ''} ${item?.state == 'Paid' ? 'text-green' : ''} ${item.state == 'Failed' ? 'text-red' : ''}`}>{item.state}</Title>
                    </td>
                  </tr>
                  )}</>}
              </table>
              {searchGridDataFilter?.length === 0 && !loader && <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No Data"
              ></Empty>}
            </InfiniteScroll>
            <Loader spinning={loader} />
          </div>
        </AppCol >
      </AppRow >
    </>
  );
};
const connectStateToProps = ({ userConfig }) => {
  return {
    userConfig: userConfig.userProfileInfo
  }
}
export default connect(connectStateToProps)(ViewPaymentLinksComponent);